import { User } from '@Core/Entities/User'

export const getUserName = (user?: User) => {
    if (!user) return ''
    return `${user?.givenName} ${user?.surname}`
}
